const values = {
    env: "PROD",
    prod_serverUrl: "https://server.contablus.com",
    dev_serverUrl: "http://192.168.100.163:8000",
    version: "2.9.1"
};

export default values;